/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PushNotificationCategoryAdminResponse } from './PushNotificationCategoryAdminResponse';
import {
    PushNotificationCategoryAdminResponseFromJSON,
    PushNotificationCategoryAdminResponseFromJSONTyped,
    PushNotificationCategoryAdminResponseToJSON,
} from './PushNotificationCategoryAdminResponse';

/**
 * 
 * @export
 * @interface ListPushNotificationCategoriesResponse
 */
export interface ListPushNotificationCategoriesResponse {
    /**
     * 
     * @type {Array<PushNotificationCategoryAdminResponse>}
     * @memberof ListPushNotificationCategoriesResponse
     */
    categories: Array<PushNotificationCategoryAdminResponse>;
}

/**
 * Check if a given object implements the ListPushNotificationCategoriesResponse interface.
 */
export function instanceOfListPushNotificationCategoriesResponse(value: object): value is ListPushNotificationCategoriesResponse {
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function ListPushNotificationCategoriesResponseFromJSON(json: any): ListPushNotificationCategoriesResponse {
    return ListPushNotificationCategoriesResponseFromJSONTyped(json, false);
}

export function ListPushNotificationCategoriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPushNotificationCategoriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'categories': ((json['categories'] as Array<any>).map(PushNotificationCategoryAdminResponseFromJSON)),
    };
}

export function ListPushNotificationCategoriesResponseToJSON(value?: ListPushNotificationCategoriesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'categories': ((value['categories'] as Array<any>).map(PushNotificationCategoryAdminResponseToJSON)),
    };
}

